<template>
  <div class='compact-risk-score-percentage' :style="cssVars" >
    <div class="result" :style="cssVars" >{{ text }}</div>
    <div class='value_section' :style="cssVars" >
      <div class='value' :style="{'color': color}" >{{ score }}</div>
      <div class='label'>{{label}} </div>
    </div>
  </div>
</template>

<script>
import { hexToRgba } from '@/utils/colorUtils';

export default {
  name: 'CompactRiskScorePercentage',
  props: {
    score: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    cssVars() {
      return {
        '--background': `${hexToRgba(this.color, 0.1)}`,
        '--color': this.color,
      };
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.compact-risk-score-percentage {
  display: flex;
  padding: $space-0-5 $space-1;
  width: fit-content;
  height: fit-content;

  .result {
    font-family: $font-family-black;
    font-size: $font-size-5xl + 0.125rem;
    text-transform: uppercase;
    color: var(--color);
  }

  .value_section {
    padding-left: $space-2;
    display: flex;
    flex-direction: column;
    margin-top: $space-2;

    .value {
      font-family: $font-family-medium;
      font-size: $font-size-2xl - 0.0625rem;
    }

    .label {
      color: var(--text-secondary);
      font-family: $font-family-regular;
      font-size: $font-size-2xs;
      letter-spacing: 1.1px;
      line-height: 15px;
      text-transform: uppercase;
      min-width: max-content;
      margin-top: -3px;
      margin-left: $space-0-5;
    }
  }
}
</style>
